var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasMessages
    ? _c(
        "div",
        { staticClass: "form-field--message-container" },
        [
          _vm._l(_vm.messages.error, function(message, messageIdx) {
            return _vm.hasErrorMessages
              ? _c("span", {
                  key: "messageIdx",
                  staticClass: "form-field--message form-field--message__error",
                  domProps: { innerHTML: _vm._s(message) }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.infoMessages, function(message, messageIdx) {
            return _vm.hasInfoMessages
              ? _c("span", {
                  key: "messageIdx",
                  staticClass: "form-field--message form-field--message__info",
                  domProps: { innerHTML: _vm._s(message) }
                })
              : _vm._e()
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2daa3ff2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2daa3ff2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/form/partials/form-field-messages-partial/index.vue
// module id = 347
// module chunks = 5